import Vue from 'vue'
import Vuex from 'vuex'
import {moduleA} from './model/configdata'

Vue.use(Vuex)

export function createStore () {
  return new Vuex.Store({
    modules: {
      a: moduleA
    },
    getters: {
      router: function (state) {
        return state.router
      },
      dict: function (state) {
        return state.dict
      }
    }
  })
}



//////////////////
// WEBPACK FOOTER
// ./store/home.js
// module id = null
// module chunks = 